import type { FunctionComponent } from 'react';

import Flex from '../../generic/Flex';

/**
 * PackageInventoryFilters renders the sidebar which contains all
 * of the various filter panels.
 */
const PackageInventoryFilters: FunctionComponent = ({ children }) => (
  <div>
    <Flex gap="16px" direction="column" align="stretch">
      {children}
    </Flex>
  </div>
);

export default PackageInventoryFilters;
